import React, { useEffect, useRef, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { CheckinLogDTO, EventAttendeeDTO, EventDetailDTO } from "../../../../models/EventDTO";
import S from "./strings";
import { PromptModal, errorText, horaLocal } from "../workshops/comun";

interface Props { campusId: number; evento: EventDetailDTO; soloLectura: boolean; reload: () => void; notify: (t: string, ok?: boolean) => void; }

interface Lectura { ok: boolean; message: string; attendee: EventAttendeeDTO | null; status: number; }

/** Control de entrada: el lector de QR escribe el código y da Enter. */
const EntradaTab: React.FC<Props> = ({ campusId, evento, soloLectura, reload, notify }) => {
	const http = HttpManager.getInstance();
	const [codigo, setCodigo] = useState<string>("");
	const [lectura, setLectura] = useState<Lectura | null>(null);
	const [log, setLog] = useState<CheckinLogDTO[] | null>(null);
	const [rehab, setRehab] = useState<EventAttendeeDTO | null>(null);
	const [busy, setBusy] = useState<boolean>(false);
	const campo = useRef<HTMLInputElement>(null);
	const vigentes = evento.attendees.filter(a => a.status === 1);
	const adentro = vigentes.filter(a => a.checkedInAt).length;

	useEffect(() => { campo.current?.focus(); }, []);

	const verLog = (a: EventAttendeeDTO | null) => {
		setLog(null);
		if (a) http.eventsService.checkins(campusId, a.id).then(r => setLog(Array.isArray(r.data) ? r.data : [])).catch(() => setLog([]));
	};
	const leer = () => {
		const qr = codigo.trim();
		if (!qr || busy) return;
		setBusy(true);
		const local = evento.attendees.find(a => a.qrCode === qr) || null;
		/*
			Con un 409/422 el servidor no devuelve la asistente: se vuelve a pedir la lista del evento (la cargada puede no
			traerla o estar vieja) antes de ofrecer Re-habilitar; si esa consulta falla, queda la de la lista cargada.
		*/
		const buscarFresca = (): Promise<EventAttendeeDTO | null> =>
			http.eventsService.details(campusId, evento.id)
				.then(r => (r.data?.attendees || []).find(a => a.qrCode === qr) || local)
				.catch(() => local);
		http.eventsService.checkin(campusId, qr)
			.then(r => { setLectura({ ok: true, message: r.data.message, attendee: r.data.attendee || local, status: 200 }); verLog(r.data.attendee || local); reload(); })
			.catch(async e => {
				const status: number = e?.response?.status || 0;
				const enRespuesta: EventAttendeeDTO | null = e?.response?.data?.attendee || null;
				const asistente = enRespuesta || ((status === 409 || status === 422) ? await buscarFresca() : local);
				if (!enRespuesta && (status === 409 || status === 422)) reload();
				setLectura({ ok: false, message: errorText(e), attendee: asistente, status });
				verLog(asistente);
			})
			.finally(() => { setBusy(false); setCodigo(""); campo.current?.focus(); });
	};

	return (
		<div className="wau-caja">
			<div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", alignItems: "baseline" }}>
				<h3>{S.tabs.entrada}</h3><span className="wau-num wau-sec">{S.entradas(adentro, vigentes.length)}</span>
			</div>
			<div className="wau-fila">
				<label className="wau-campo" style={{ flex: "1 1 320px" }}><span className="wau-lab">{S.codigo}</span>
					<input ref={campo} className="wau-entrada wte-entrada-qr" value={codigo} disabled={soloLectura} autoComplete="off"
						onChange={e => setCodigo(e.target.value)} onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); leer(); } }} /></label>
				<button type="button" className="wau-btn p" disabled={soloLectura || busy || !codigo.trim()} onClick={leer}>{S.leer}</button>
			</div>
			{lectura ? (
				<div className={"wte-lectura " + (lectura.ok ? "ok" : "mal")} role="status">
					{lectura.message}
					{lectura.attendee ? <span className="sub">{[lectura.attendee.name, lectura.attendee.kindLabel, lectura.attendee.tableNo ? S.colMesa + " " + lectura.attendee.tableNo : null, lectura.attendee.hostName ? S.invitaA(lectura.attendee.hostName) : null].filter(Boolean).join(" · ")}</span> : null}
					{!lectura.ok && lectura.status === 409 && lectura.attendee && !soloLectura ? (
						<div style={{ marginTop: 10 }}><button type="button" className="wau-btn s" onClick={() => setRehab(lectura.attendee)}>{S.rehabilitar}</button></div>
					) : null}
				</div>
			) : null}
			{log && log.length > 0 ? (
				<div className="wau-hilo">
					<span className="wau-lab">{S.lecturas}</span>
					{log.map(l => <div key={l.id}><span className="cuando wau-num">{horaLocal(l.at)}</span>{S.acciones[l.action] || l.action}{l.by ? " · " + l.by : ""}{l.note ? " · " + l.note : ""}</div>)}
				</div>
			) : null}
			{rehab ? <PromptModal title={S.rehabTitulo(rehab.name)} label={S.rehabNota} confirm={S.rehabilitar} busy={busy} onCancel={() => setRehab(null)}
				onConfirm={(nota) => {
					setBusy(true);
					http.eventsService.reenable(campusId, rehab.id, nota)
						.then(() => { notify(S.rehabOk); setLectura(null); verLog(rehab); setRehab(null); reload(); })
						.catch(e => notify(errorText(e), false))
						.finally(() => { setBusy(false); campo.current?.focus(); });
				}} /> : null}
		</div>
	);
};

export default EntradaTab;
